var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "gg-card-title",
                {
                  staticClass: "pb-0 pt-0"
                },
                [_vm._v(" Manage Domain Names ")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "text-right",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "hidden-xs-only"
                },
                [
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mr-1",
                      attrs: {
                        tile: "",
                        elevation: "0",
                        color: "primary",
                        right: "",
                        to: {
                          name: "domain_registration"
                        }
                      }
                    },
                    [_vm._v(" Register a Domain ")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mx-1",
                      attrs: {
                        tile: "",
                        elevation: "0",
                        secondary: "",
                        right: "",
                        to: {
                          name: "domain_transfer"
                        }
                      }
                    },
                    [_vm._v(" Transfer a Domain ")]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "hidden-sm-and-up"
                },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        bottom: "",
                        left: "",
                        "offset-y": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function fn(_ref) {
                            var on = _ref.on
                            return [
                              _c(
                                "gg-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      tile: "",
                                      elevation: "0",
                                      small: "",
                                      secondary: ""
                                    }
                                  },
                                  on
                                ),
                                [
                                  _vm._v(" Actions "),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        right: "",
                                        dark: ""
                                      }
                                    },
                                    [_vm._v("mdi-menu-down")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-item",
                            {
                              attrs: {
                                to: {
                                  name: "domain_registration"
                                }
                              }
                            },
                            [
                              _c("v-list-item-title", [
                                _vm._v("Register Domain")
                              ])
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            {
                              attrs: {
                                to: {
                                  name: "domain_transfer"
                                }
                              }
                            },
                            [
                              _c("v-list-item-title", [
                                _vm._v("Transfer Domain")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("v-row"),
      _c("domains-transfer-list"),
      _c(
        "gg-card",
        [
          _c("gg-card-header", [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-sm-row flex-column justify-between align-start gap-sm align-md-center"
              },
              [
                _c("h2", [_vm._v("My Domain Names")]),
                _c(
                  "div",
                  {
                    staticClass: "w-100",
                    staticStyle: {
                      "max-width": "440px"
                    }
                  },
                  [
                    _c("services-search", {
                      attrs: {
                        compact: ""
                      },
                      model: {
                        value: _vm.search,
                        callback: function callback($$v) {
                          _vm.search = $$v
                        },
                        expression: "search"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "gg-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  loading: !_vm.domainsPopulated,
                  headers: _vm.headers,
                  items: _vm.managableDomains,
                  "footer-props": {
                    itemsPerPageOptions: _vm.pagination
                  },
                  search: _vm.search
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.renewaldate",
                    fn: function fn(_ref2) {
                      var item = _ref2.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatRenewalDate(
                                _vm.parseRenewalDate(item.renewaldate)
                              )
                            ) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.domain",
                    fn: function fn(_ref3) {
                      var item = _ref3.item
                      return [
                        _c(
                          "router-link",
                          {
                            staticClass: "ggs-item-title",
                            attrs: {
                              to: "/domains/".concat(item.id)
                            }
                          },
                          [_vm._v(" " + _vm._s(item.domain) + " ")]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: {
                              top: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function fn(_ref4) {
                                    var on = _ref4.on,
                                      attrs = _ref4.attrs
                                    return [
                                      item.cancellation_pending
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "pl-1",
                                              attrs: {
                                                to: "/cancellations/".concat(
                                                  item.cancellation_id
                                                ),
                                                "aria-label": "View Request"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        color: "orange",
                                                        small: ""
                                                      }
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [_vm._v("mdi-alert-outline")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("div", [
                              _vm._v(
                                "Your service will be active until the due date."
                              )
                            ]),
                            _c("div", [
                              _vm._v("Click to view/update your request.")
                            ])
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.status",
                    fn: function fn(_ref5) {
                      var item = _ref5.item
                      return [
                        _c(
                          "v-icon",
                          {
                            staticClass: "pb-1",
                            attrs: {
                              small: "",
                              color: _vm.statusColor(item.status)
                            }
                          },
                          [_vm._v(" mdi-circle ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "pl-1"
                          },
                          [_vm._v(" " + _vm._s(item.status) + " ")]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.idprotect",
                    fn: function fn(_ref6) {
                      var item = _ref6.item
                      return [
                        _c(
                          "v-icon",
                          {
                            staticClass: "pb-1",
                            attrs: {
                              small: "",
                              color: _vm.idProtectColor(
                                item.idprotect,
                                item.idprotect_eligible,
                                item.idprotect_status
                              )
                            }
                          },
                          [_vm._v(" mdi-circle ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "pl-1"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.idProtectStatus(
                                    item.idprotect,
                                    item.idprotect_eligible,
                                    item.idprotect_status
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function fn(_ref7) {
                      var item = _ref7.item
                      return [
                        _vm.serviceManagable(item)
                          ? _c(
                              "gg-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  tile: "",
                                  to: "/domains/".concat(item.id)
                                }
                              },
                              [_vm._v(" Manage ")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }